export const getDefaultLabel = ({
  labels,
  const_key,
}: {
  labels: {label: string}[];
  const_key: string;
}) => (labels.length > 0 ? labels[0].label : const_key);
